import Agreement from './agreement';
import ChannelDistribution from './channel-distribution';
import Contract from './contract';
import DigitalDistribution from './digital-distribution';
import ExtendedList from './list/ContractExtendedTemplates';
import List from './list/ContractTemplates';
import MerchDistribution from './merch-distribution';
import PhysicalDistribution from './physical-distribution';
import Section from './section';

export default {
  List,
  ExtendedList,
  Agreement,
  Section,
  DigitalDistribution,
  Contract,
  PhysicalDistribution,
  MerchDistribution,
  ChannelDistribution,
};
